import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignSnackEditUUIDSnackPresenter } from "./presenter";
import { useSnackListQuery } from "../../model";

type Props = {
	hotelID: string;
	uuid: string;
};

export const DesignSnackEditUUIDSnackContainer = ({ hotelID, uuid }: Props) => {
	const { data } = useSnackListQuery({ hotelID, uuid });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID })} />;
	}

	return <DesignSnackEditUUIDSnackPresenter hotelID={hotelID} data={data} />;
};

DesignSnackEditUUIDSnackContainer.displayName = "DesignSnackEditUUIDSnackContainer";
